import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const forgeAdminSettingsRoute: InvariantRoute = {
	name: 'forge-spa-admin-settings',
	path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?',
};
